import { axiosRequest } from '@/api/default.js';
import { METHOD } from '@/api/default.js';
import constants from '@/constants';

// Plans API
export async function getPlans(params = {}) {
    const url = constants.URL.BILLING_PLANS;
    const response = await axiosRequest({
        url,
        method: METHOD.GET,
        requestName: 'GET BILLING PLANS',
        params,
        isLoader: false,
    });
    return response == null ? { plans: [], total: 0 } : response;
}

export async function getPlanById(planId) {
    const url = constants.URL.BILLING_PLAN_BY_ID.replace('{plan_id}', planId);
    const response = await axiosRequest({
        url,
        method: METHOD.GET,
        requestName: 'GET BILLING PLAN',
        isLoader: false,
    });
    return response;
}

export async function createPlan(planData) {
    const url = constants.URL.BILLING_PLANS;
    const response = await axiosRequest({
        url,
        method: METHOD.POST,
        requestName: 'CREATE BILLING PLAN',
        data: planData,
        isLoader: true,
    });
    return response;
}

export async function updatePlan(planId, planData) {
    const url = constants.URL.BILLING_PLAN_BY_ID.replace('{plan_id}', planId);
    const response = await axiosRequest({
        url,
        method: METHOD.PUT,
        requestName: 'UPDATE BILLING PLAN',
        data: planData,
        isLoader: true,
    });
    return response;
}

export async function deletePlan(planId) {
    const url = constants.URL.BILLING_PLAN_BY_ID.replace('{plan_id}', planId);
    const response = await axiosRequest({
        url,
        method: METHOD.DELETE,
        requestName: 'DEACTIVATE BILLING PLAN',
        isLoader: true,
    });
    return response;
}

// Refunds API
export async function getRefunds() {
    const url = constants.URL.BILLING_REFUNDS;
    const response = await axiosRequest({
        url,
        method: METHOD.GET,
        requestName: 'GET REFUND REQUESTS',
        isLoader: false,
    });
    return response == null ? [] : response;
}

export async function processRefund(refundId, approve, notes = null) {
    const url = constants.URL.BILLING_REFUND_PROCESS.replace(
        '{refund_id}',
        refundId
    );
    const response = await axiosRequest({
        url,
        method: METHOD.POST,
        requestName: 'PROCESS REFUND',
        data: { approve, notes },
        isLoader: true,
    });
    return response;
}
